import { useEffect } from "preact/hooks";

const updateTag = (tagName, attrName, key, valueAttr, value) => {
  let tag = document.querySelector(`head > ${tagName}[${attrName}="${key}"]`);
  if (!tag) {
    tag = document.createElement(tagName);
    document.head.appendChild(tag);
    tag.setAttribute(attrName, key);
  }
  tag.setAttribute(valueAttr, value);
};

const updateMetaTag = (key, content) => {
  const attrName = key.startsWith("og:") ? "property" : "name";
  updateTag("meta", attrName, key, "content", content);
};

const updateLinkTag = (key, href) => {
  updateTag("link", "rel", key, "href", href);
};

const removeTag = (tagName, attrName, key) => {
  const tag = document.querySelector(`head > ${tagName}[${attrName}="${key}"]`);
  if (tag) {
    tag.parentNode.removeChild(tag);
  }
};

const removeMetaTag = (key) => {
  const attrName = key.startsWith("og:") ? "property" : "name";
  removeTag("meta", attrName, key);
};

const removeLinkTag = (key) => {
  removeTag("link", "rel", key);
};

const getBaseUrl = () => {
  let protocol = "https:";
  let domain = process.env.SITE_DOMAIN;
  if (domain === "auto" && typeof window !== "undefined") {
    protocol = window.location.protocol;
    domain = window.location.host;
  }
  return `${protocol}//${domain}`;
};

const Head = ({ data = undefined }) => {
  useEffect(() => {
    if (typeof document !== "undefined") {
      if (data) {
        if (data.title) {
          document.title = data.title;
        }
        if (data.url) {
          updateMetaTag("og:url", `${getBaseUrl()}${data.url}`);
          updateLinkTag("canonical", `${getBaseUrl()}${data.url}`);
        } else {
          removeMetaTag("og:url");
          removeLinkTag("canonical");
        }
        if (data.og_type) {
          updateMetaTag("og:type", data.og_type);
        } else {
          removeMetaTag("og:type");
        }
        if (data.og_image) {
          updateMetaTag("og:image", `${getBaseUrl()}${data.og_image}`);
        } else {
          removeMetaTag("og:image");
        }
        if (data.og_title) {
          updateMetaTag("og:title", data.og_title);
        } else {
          removeMetaTag("og:title");
        }
        if (data.og_description) {
          updateMetaTag("og:description", data.og_description);
        } else {
          removeMetaTag("og:description");
        }
        if (data.description) {
          updateMetaTag("description", data.description);
        } else {
          removeMetaTag("description");
        }
      }

      if (typeof gtag !== "undefined") {
        // Send GA4 (Google Analytics) page view
        gtag("event", "page_view");
      }
    }
  }, [data]);
  return null;
};

export default Head;
